function getOptionSwatchImageUrl(input) {
  const label = input.closest('label') || input.closest('.cl-po--swatch-item');
  if (!label) return null;
  const img = label.querySelector('img');
  if (!img) return null;

  const rawSrc = img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src');
  if (!rawSrc) return null;

  return rawSrc.replace(/_(\d+)x(\.[a-z]+)(\?.*)?$/i, '_1200x$2$3');
}

function updateMainGalleryImage(productPage, newSrc, altText, newSrcset) {
  var gallery = productPage.querySelector('[data-js-product-gallery]');
  if (!gallery) return;
  var mainImg = gallery.querySelector('.product-gallery-item .lazy-image img');
  if (!mainImg) return;
  mainImg.src = newSrc;
  mainImg.srcset = newSrcset || newSrc;
  if (altText) mainImg.alt = altText;
  var zoom = gallery.querySelector('[data-image-zoom]');
  if (zoom) zoom.setAttribute('data-image', newSrc);
}

var _imgSwapScrollTimer = null;
var _lastDirectSwapTime = 0;
var READY_CHECK_INTERVAL_MS = 200;
var MAX_READY_ATTEMPTS = 50;
var STARTUP_SYNC_INTERVAL_MS = 120;
var MAX_STARTUP_SYNC_ATTEMPTS = 12;

function scrollGalleryToFirstSlide(productPage) {
  var gallery = productPage.querySelector('[data-js-product-gallery]');
  if (!gallery) return;
  var slider = gallery.querySelector('css-slider');
  if (slider && slider.sliderEnabled && typeof slider.changeSlide === 'function') {
    slider.changeSlide(0);
  }
}

function shouldSyncOptionImage(input) {
  if (!input.classList.contains('cl-po--input')) return false;
  if (input.type !== 'radio') return false;
  return /^v_/.test(input.name || '');
}

function getCurrentVariantOptionValues(variants) {
  if (!variants || !variants.currentVariant || typeof variants.currentVariant !== 'object') return [];
  var variant = variants.currentVariant;
  var valueSet = new Set();

  if (Array.isArray(variant.options)) {
    variant.options.forEach(function (value) {
      valueSet.add(value);
    });
  }

  ['option1', 'option2', 'option3'].forEach(function (key) {
    if (variant[key]) valueSet.add(variant[key]);
  });

  return Array.from(valueSet)
    .map(function (value) {
      return (value == null ? '' : String(value)).trim().toLowerCase();
    })
    .filter(Boolean);
}

function findSyncCandidateInput(productPage) {
  var scope = productPage || document;
  var checkedRadio = scope.querySelector('.cl-po--input[type="radio"][name^="v_"]:checked')
    || document.querySelector('.cl-po--input[type="radio"][name^="v_"]:checked');
  if (checkedRadio) return checkedRadio;

  var variants = scope.querySelector('product-variants[data-main-product-variants]')
    || document.querySelector('product-variants[data-main-product-variants]');
  var selectedValues = getCurrentVariantOptionValues(variants);
  if (!selectedValues.length) return null;

  var radios = Array.prototype.slice.call(scope.querySelectorAll('.cl-po--input[type="radio"][name^="v_"]'));
  if (!radios.length) {
    radios = Array.prototype.slice.call(document.querySelectorAll('.cl-po--input[type="radio"][name^="v_"]'));
  }

  var matching = radios.filter(function (radio) {
    return selectedValues.includes(String(radio.value || '').trim().toLowerCase());
  });
  if (!matching.length) return null;

  var colorMatch = matching.find(function (radio) {
    return /colour|color/i.test(radio.name || '');
  });
  return colorMatch || matching[0];
}

function runWhenLiveOptionsReady(productPage, onReady) {
  var attempts = 0;
  (function check() {
    attempts += 1;
    if (productPage.querySelector('.cl-po--input') || document.querySelector('.cl-po--input')) {
      onReady();
      return;
    }
    if (attempts < MAX_READY_ATTEMPTS) {
      setTimeout(check, READY_CHECK_INTERVAL_MS);
    }
  })();
}

function handleOptionImageSwap(input, isFromPoll, forceSync) {
  if (!(input instanceof HTMLInputElement)) return;
  if (!input.matches('.cl-po--input')) return;
  if (!shouldSyncOptionImage(input)) return;

  var productPage = input.closest('product-page') || document.querySelector('product-page[data-js-product-component]');
  if (!productPage) return;

  if (!forceSync && !input.checked) return;

  var newSrc = getOptionSwatchImageUrl(input);
  if (!newSrc) return;

  updateMainGalleryImage(productPage, newSrc, input.value);
  scrollGalleryToFirstSlide(productPage);

  if (!isFromPoll) {
    _lastDirectSwapTime = Date.now();
  }

  clearTimeout(_imgSwapScrollTimer);
  _imgSwapScrollTimer = setTimeout(function () {
    scrollGalleryToFirstSlide(productPage);
  }, 800);
}

document.addEventListener('change', function (event) {
  handleOptionImageSwap(event.target);
}, true);

document.addEventListener('input', function (event) {
  handleOptionImageSwap(event.target);
}, true);

document.addEventListener('click', function (event) {
  const swatch = event.target.closest('.cl-po--swatch-item');
  if (!swatch) return;
  const input = swatch.querySelector('input.cl-po--input');
  if (!input) return;
  const inputId = input.id;
  setTimeout(function () {
    const freshInput = inputId ? document.getElementById(inputId) : swatch.querySelector('input.cl-po--input');
    if (freshInput) handleOptionImageSwap(freshInput);
  }, 200);
}, true);

(function () {
  var _prevStates = {};
  var _pollingIntervalId = null;

  function pollRadios() {
    if (Date.now() - _lastDirectSwapTime < 2000) return;

    var productPage = document.querySelector('product-page[data-js-product-component]');
    if (!productPage) return;

    var radios = productPage.querySelectorAll('.cl-po--input[type="radio"]');
    /* c8 ignore start */
    radios.forEach(function (rb) {
      var key = rb.name + '=' + rb.value;
      var wasChecked = _prevStates[key];
      var isChecked = rb.checked;

      if (isChecked && wasChecked !== true) {
        handleOptionImageSwap(rb, true);
      }
      _prevStates[key] = isChecked;
    });
    /* c8 ignore end */
  }

  function ensurePolling() {
    if (_pollingIntervalId) {
      var currentProductPage = document.querySelector('product-page[data-js-product-component]');
      if (currentProductPage && currentProductPage.querySelector('.cl-po--input')) {
        return;
      }
      clearInterval(_pollingIntervalId);
      _pollingIntervalId = null;
      _prevStates = {};
    }
    _pollingIntervalId = setInterval(function () {
      var productPage = document.querySelector('product-page[data-js-product-component]');
      if (!productPage || !productPage.querySelector('.cl-po--input')) {
        clearInterval(_pollingIntervalId);
        _pollingIntervalId = null;
        _prevStates = {};
        return;
      }
      pollRadios();
    }, 300);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var productPage = document.querySelector('product-page[data-js-product-component]');
    if (!productPage) return;
    runWhenLiveOptionsReady(productPage, function () {
      ensurePolling();

      var variants = productPage.querySelector('product-variants[data-main-product-variants]');
      if (variants) {
        variants.addEventListener('VARIANT_CHANGE', function () {
          setTimeout(function () {
            scrollGalleryToFirstSlide(productPage);
            var variantInput = findSyncCandidateInput(productPage);
            if (variantInput) handleOptionImageSwap(variantInput, true, !variantInput.checked);
          }, 50);
        });
      }

      var startupAttempts = 0;
      (function syncCheckedRadioOnStartup() {
        startupAttempts += 1;
        var startupInput = findSyncCandidateInput(productPage);
        if (startupInput) {
          handleOptionImageSwap(startupInput, true, !startupInput.checked);
          return;
        }
        if (startupAttempts < MAX_STARTUP_SYNC_ATTEMPTS) {
          setTimeout(syncCheckedRadioOnStartup, STARTUP_SYNC_INTERVAL_MS);
        }
      })();
    });
  });
})();
